import { ElementRef, EventEmitter } from "@angular/core";
import { IDynamicTabDefinition } from "@app/directives/_layout/v-tabs/v-tabs.component";
import { IDriver } from "@app/interfaces/IDriver";
import { IVehicle } from "@app/interfaces/IVehicle";
import { IGroupWithIds } from "@app/main/components/resourceManagement/groups/_models/IGroupWithIds";
import { TimeFilterType } from "@app/main/components/reports/enums/TimeFilterType";

export interface IFilterBarChange<T = any> {
    change: EventEmitter<T>;
}

export interface IFilterBarFilter<T = any> extends IFilterBarChange<T> {

    selected: T;

    name: string;
    icon: string;

    type: FilterTriggerType;
    visible?: boolean;

    elementRef: ElementRef<HTMLElement>;
    filterPredicate?: FilterBarItemPredicate<T>;
}

export interface IVerticalFilterListItem<T = any> {
    name: string;
    tooltip?: string;
    count?: number;
    countAsPercentageOfMax?: number;
    icon?: string;
    color?: string;
    key?: any;

    data?: T;
    selected?: boolean;

    predicate: (value?: T) => boolean;
}

export interface IFilterBarListWithCount<T = any> extends IFilterBarChange<T> {
    selectedItems: IVerticalFilterListItem[];
    items: IVerticalFilterListItem<T>[];
    multiSelectMode: 'every-filter' | 'some-filter';
    maxListItemCount: number;

    updateList(data: any);
}

export class FilterBarListIterable<T> {
    mode: 'every-filter' | 'some-filter';
    selectedItems: IVerticalFilterListItem<T>[]

    constructor(mode: 'every-filter' | 'some-filter', selectedItems: IVerticalFilterListItem<T>[]) {
        this.mode = mode;
        this.selectedItems = selectedItems;
    }
}

export type FilterTriggerType = "sourcedata" | "group" | "vehicle" | "driver" | "tag" | "date" | "search" | "filter" | "filterlist" | "custom" | "vehicletype" | "datetime";

export interface IAggregateFilterEvent<T> extends Partial<Record<FilterTriggerType, any>> {
    trigger?: FilterTriggerType;

    group?: IGroupWithIds;
    vehicle?: IVehicle;
    driver?: IDriver;
    date?: Date[];
    datetime?: { startDate: Date, endDate: Date, startTime: string, endTime: string, timeFilterType: TimeFilterType }

    custom?: any;

    filter?: (item: T) => boolean;
    filteredData?: T[];
}

export interface FilterChange {
    type: FilterTriggerType,
    event: any,
    options?: { customName?: string, filterData?: boolean }
}

export type FilterBarItemPredicate<T> = (item: any, value?: T) => boolean;
export type FilterBarItemSearchPredicate<T> = (item: T, text: string) => boolean;

export interface IFilterBarTab<T> extends IDynamicTabDefinition<T> {
    predicate: (item: T) => boolean;
}
